import { format, parseISO, set } from 'date-fns'
import * as Yup from 'yup'

import { DATE_API_DATA_FORMAT_SHORT } from '../../../constants/date'
import { toUkTimezoneDate } from '../../../utils/date'
import { TASK_FORM_DEADLINE_FIELD_NAME } from '../../Task'

export function getCalendarTaskMoveInitialValues({ date, item, timezone }) {
  const day = parseISO(date)

  return {
    [TASK_FORM_DEADLINE_FIELD_NAME]: set(
      toUkTimezoneDate(item.deadline, timezone),
      { date: day.getDate(), month: day.getMonth(), year: day.getFullYear() }
    ),
  }
}

export function getCalendarTaskMoveValidationSchema() {
  return Yup.object({
    [TASK_FORM_DEADLINE_FIELD_NAME]: Yup.date().nullable().required(true),
  })
}

export function getCalendarTaskMoveDate({ timezone, values }) {
  const deadline = values[TASK_FORM_DEADLINE_FIELD_NAME]

  return deadline
    ? format(toUkTimezoneDate(deadline, timezone), DATE_API_DATA_FORMAT_SHORT)
    : null
}
